import { takeEvery, fork, put, call, select } from 'redux-saga/effects';
import { isEmpty } from 'lodash-es';
import { Logger } from '../services/errors/appLogger';

import {
    resend2FACodePOST,
    setNewPassword,
    resendActivationEmail,
    resendActivationEmailUser,
    setNewPasswordUser,
} from '../services/ElasticApi';

import { Resend2FACodeAction, AuthActionTypes, ResendActivationEmailAction, ResendActivationEmailUserAction } from '../store/auth/types';
import {
    AuthError,
    Resend2FACodeSuccess,
    ResendActivationEmailError,
    ResendActivationEmailSuccess,
    ResendActivationEmailUser,
} from '../store/auth/actions';
import { SessionNewPasswordStartAction } from '@api/store/session/types';
import { SetNewPasswordFailed, SetNewPasswordSuccess } from '@api/store/session/actions';
import { HomePaths } from '@api/services/dictionaries/paths';
import { parseUrlParams } from '@api/services/tools/handleUrlParams';
import { AccountState } from '@api/store/account/types';
import { getAccountStore } from '@api/store/account/actions';

function* resend2FACodeLogin({ payload, meta }: Resend2FACodeAction): any {
    try {
        yield call(resend2FACodePOST, payload);
        yield put(Resend2FACodeSuccess(meta));
    } catch (e) {
        Logger.error(e?.response?.data?.Error);
        yield put(AuthError(meta));
    }
}

function* resend2FACodeLoginWatcher(): any {
    yield takeEvery(AuthActionTypes.RESEND_2FA, resend2FACodeLogin);
}

function* setNewPasswordSaga({ meta, payload }: SessionNewPasswordStartAction): any {
    const { token, password } = payload;

    try {
        const params = parseUrlParams(location.search);
        const apiCall = params?.option === 'user' ? setNewPasswordUser : setNewPassword;
        yield call(apiCall, token, password);

        yield put(SetNewPasswordSuccess(meta));
    } catch (e) {
        const error = e.response ? e.response.data.Error : e;

        Logger.error(error);
        yield put(SetNewPasswordFailed(meta, error));
    }
}

function* watchSetNewPassword(): any {
    yield takeEvery('@@session/SEND_NEW_PASSWORD_START', setNewPasswordSaga);
}

function* resendActivationEmailLogin(action: ResendActivationEmailAction | ResendActivationEmailUserAction): any {
    const { payload, meta, type } = action;
    const metaToPass = type === AuthActionTypes.RESEND_ACTIVATION_EMAIL_USER ? action?.previousMeta : meta;
    try {
        if (type === AuthActionTypes.RESEND_ACTIVATION_EMAIL_USER) {
            const { BrandingInfo, isBrandingInfoLoaded }: AccountState = yield select(getAccountStore);
            const DashboardUrl = isBrandingInfoLoaded && isEmpty(BrandingInfo) ? ACCOUNTDASHBOARD : location.origin;
            yield call(resendActivationEmailUser, { UserName: payload.Email, DashboardUrl, UrlPath: HomePaths.RegisterUser });
        } else {
            yield call(resendActivationEmail, { ReturnUrl: location.origin, ...payload });
        }
        yield put(ResendActivationEmailSuccess(metaToPass));
    } catch (e) {
        if (e?.response?.data?.MessageID === 'login_invalidusername') {
            yield put(ResendActivationEmailUser(payload, meta));
        } else {
            const error = e?.response?.data?.Error ? e.response.data.Error : e.message;
            Logger.error(error);
            yield put(ResendActivationEmailError(e?.response?.data, metaToPass));
        }
    }
}

function* resendActivationEmailLoginWatcher(): any {
    yield takeEvery([AuthActionTypes.RESEND_ACTIVATION_EMAIL, AuthActionTypes.RESEND_ACTIVATION_EMAIL_USER], resendActivationEmailLogin);
}

const AuthSagas = [fork(resend2FACodeLoginWatcher), fork(watchSetNewPassword), fork(resendActivationEmailLoginWatcher)];

export default AuthSagas;
